import { get } from 'lodash';
import encodeName from 'apps/gtm/utils/encodeName';
import getGTMProductListName from 'apps/gtm/utils/getGTMProductListName';

export default function sendSingleSectionProductImpressions(sectionWithFops, pageType, section) {
  const { fops = [] } = sectionWithFops || {};

  if (!window.dataLayer) {
    return;
  }

  const productImpressions = fops.map((fop, index) => {
    const { product, fopAttributes = {} } = fop;

    return {
      ...(fopAttributes.sponsored_item_click_beacon && { adProvider: 'Criteo' }),
      brand: (product.brand || {}).name,
      category: product.mainCategory,
      id: String(product.sku),
      list: getGTMProductListName(pageType, section),
      name: encodeName(product.name),
      position: index,
      price: product.price.current,
    };
  });

  window.dataLayer.push({
    event: 'eecProductInteractionEvent',
    ecommerce: {
      impressions: productImpressions,
    },
    pageTypeDimension: pageType,
    productSectionDimension: get(section, 'attributes.title'),
    uaEventCategory: 'E-Commerce',
    uaEventAction: 'productImpressions',
    uaEventLabel: `${pageType}|${get(section, 'attributes.title')}`,
    uaEventValue: productImpressions.length,
  });
}
